import { stopPropagation } from '../../../../utils/events'
import Button from '../../../Button'

import { TABLE_CELL_EDIT_BUTTON_SIZE } from './TableCellEditButton.constants'

import * as styles from './TableCellEditButton.module.css'

import EditIcon from '../../../../icons/edit.svg'

function TableCellEditButton({
  Icon = EditIcon,
  className = styles.edit,
  height = TABLE_CELL_EDIT_BUTTON_SIZE,
  onClick,
  ...restProps
}) {
  function handleClick(event) {
    stopPropagation(event)
    onClick()
  }

  return (
    <Button.Outlined
      {...restProps}
      isGrey
      beforeIconProps={{ Icon }}
      className={className}
      height={height}
      onClick={handleClick}
    />
  )
}

export default TableCellEditButton
